var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class=\'dropzone-file-row\'>\n  <div class=\'dropzone-file\'>\n    <img class=\'dropzone-thumbnail\' data-dz-thumbnail>\n    <i class=\'dropzone-icon material-icons\'>insert_drive_file</i>\n    <span class=\'dropzone-filename\' data-dz-name></span>\n    <span class=\'dropzone-filesize\' data-dz-size></span>\n    <i class=\'dropzone-remove material-icons\' data-dz-remove>close</i>\n  </div>\n  <div class=\'dropzone-progress-bar\'>\n    <div class=\'dropzone-progress\' data-dz-uploadprogress></div>\n  </div>\n  <div class=\'dropzone-error-message\' data-dz-errormessage></div>\n</div>\n';
}
return __p;
};
